import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	margin: auto;
	max-width: 1200px;
	min-height: 50vh;
	width: 90%;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-size: 32px;
	font-weight: bold;
	margin-bottom: 8px;
	margin-top: 32px;
`;

const p = styled.p`
	font-size: 17px;
	font-weight: normal;
	margin-bottom: 32px;
	margin: 0;
`;

const NavLink = styled.div``;

const SprayDecorating = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Spray Decorating</Title>
			<p>
				What are the advantages of spray decorating compared to hand paining or
				rollering? <br />
				Well two things comes to mind: The quality of the finish and the speed
				involved, a four day job reduced to one day
			</p>

			<p>
				Open cell ceilings
				<br />
				Metal ceilings <br />
				Plaster board <br />
				<br />
				All can be refinished to match any Ral code, if you have the colour we
				have the finish.
				<br />
				Please see our gallery photos
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default SprayDecorating;



// WEBPACK FOOTER //
// ./src/components/page/spray-decorating.js